import {EntityType} from "../core/entityType";
import {Operation} from "../core/operation";

export const entityType = EntityType.Vocabulary;
export const entityOperations = [
  Operation.getAll,
  Operation.get,
  Operation.create,
  Operation.delete,
  Operation.update,
];
